import { PrinterPosWrenchIcon } from './PrinterPosWrenchIcon';

/**
 * author: Colton Wiscombe
 * id 458EB3B4-89F2-4E46-A6D6-485A2081F627
 * name printer-pos-wrench
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-wrench.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleWrenchIcon = PrinterPosWrenchIcon;
export default PrinterPointOfSaleWrenchIcon